import FechamentoVendasCupomService from "@/services/FechamentoVendasCupomService";

export const fechamentoVendasCupom = {
  namespaced: true,
  state: {
    fechamentoVendasCupom: {},
  },
  actions: {
    getFechamentoVendasCupom({ commit }, payload) {
      return FechamentoVendasCupomService.GetFechamentoVendasCupom(
        payload
      ).then(
        (fechamentoVendasCupom) => {
          return Promise.resolve(fechamentoVendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFechamentoVendasCupom({ commit }, payload) {
      return FechamentoVendasCupomService.PostFechamentoVendasCupom(
        payload
      ).then(
        (fechamentoVendasCupom) => {
          return Promise.resolve(fechamentoVendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFechamentoVendasCupom({ commit }, payload) {
      return FechamentoVendasCupomService.PutFechamentoVendasCupom(
        payload
      ).then(
        (fechamentoVendasCupom) => {
          return Promise.resolve(fechamentoVendasCupom);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFechamentoVendasCupom({ commit }, payload) {
      return FechamentoVendasCupomService.DeleteFechamentoVendasCupom(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFechamentoVendasCupomOData({ commit }, payload) {
      return FechamentoVendasCupomService.GetFechamentoVendasCupomOData(
        payload
      ).then(
        (fechamentoVendasCupom) => {
          return Promise.resolve(fechamentoVendasCupom);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    imprimirSuprimentoSangria({ commit }, payload) {
      return FechamentoVendasCupomService.ImprimirSuprimentoSangria(
        payload
      ).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default fechamentoVendasCupom;
